import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  IFirstSectionPayload,
  IFirstSectionResponse,
  ActionType,
} from "models/dashboard/firstSection";
import { httpStatus } from "configs/httpStatus";
import { fetchFirstSectionData } from "services/dashboard";
import { handleSuccesAction, handleErrorAction } from "./firstSectionActions";

function* getFirstSectionSaga({ payload }: { payload: IFirstSectionPayload }) {
  try {
    const response: IFirstSectionResponse = yield call(
      fetchFirstSectionData,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetFirstSectionWatcher() {
  yield takeLatest(
    ActionType.GET_FIRST_SECTION_DATA as any,
    getFirstSectionSaga
  );
}

export default [fork(onGetFirstSectionWatcher)];
